import axios from 'axios'
import { add_assessment } from '../templatesSlice'

async function check_test(data,setChecking,dispatch,add_test,setOpen,setMessage,navigate){

try{

    setChecking(true)
const URL =`${process.env.REACT_APP_SERVER_AUTH_URL}check-test/`

const checkTest = await axios.post(URL,data,{
           headers:{
                  "Content-Type":"application/json",
                  "Authorization":`Bear ${data?.token}`
              }
       }).catch(err=>{console.log(err)})

if (checkTest?.status == 200 && checkTest?.data?.success == true) {
    
    setChecking(false)
    if (checkTest?.data?.isTest) {
        await dispatch(add_test(checkTest?.data?.test))
        if(checkTest?.data?.test?.isRealTime){
            navigate('/TakeTest') 
        }else{
            navigate('/TakeOpenTest') 
        }      
    } else {
        await dispatch(add_assessment(checkTest?.data?.assessment))
        navigate('/takeAssessment')
    }


}else{
    setMessage(checkTest?.data?.message)
    setOpen(true)
    setChecking(false)
}
}catch(err){
    setChecking(false)
console.log(err)
}
}

export default check_test